import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './IdleWarningModal.module.css';

interface IdleWarningModalProps {
  isOpen: boolean;
  remainingSeconds: number;
  onContinue: () => void;
}

export const IdleWarningModal: React.FC<IdleWarningModalProps> = ({
  isOpen,
  remainingSeconds,
  onContinue,
}) => {
  const [countdown, setCountdown] = useState(remainingSeconds);

  useEffect(() => {
    setCountdown(remainingSeconds);
  }, [remainingSeconds]);

  useEffect(() => {
    if (!isOpen || countdown <= 0) return;

    const timer = setInterval(() => {
      setCountdown((prev) => Math.max(0, prev - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen, countdown]);

  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.icon}>⏱️</div>
        <h2 className={styles.title}>{t('idle.title')}</h2>
        <p className={styles.message}>
          {t('idle.message')}
        </p>
        <div className={styles.countdown}>
          <span className={styles.countdownNumber}>{countdown}</span>
          <span className={styles.countdownLabel}>{t('idle.seconds')}</span>
        </div>
        <button 
          className={styles.continueButton}
          onClick={onContinue}
        >
          {t('idle.continueButton')}
        </button>
      </div>
    </div>
  );
};
